import { useEffect, useState } from "react";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { checkIfPotentialExhaustVisits } from "../utils/checkIfPotentialExhaustVisits";

/**
 * Returns `true` when any "Auth on File" J-code's remaining visits
 * may be exhausted by scheduled visits between order creation and
 * the date of service.
 */
export const usePotentialExhaustVisits = () => {
  const { generalOrderDetails, authOnFileDetails } =
    useDataAccumulatorForSingleOrder();
  const [potentialExhaustVisits, setPotentialExhaustVisits] =
    useState<boolean>(false);

  useEffect(() => {
    if (generalOrderDetails && authOnFileDetails) {
      setPotentialExhaustVisits(
        checkIfPotentialExhaustVisits(
          generalOrderDetails?.order ?? {},
          authOnFileDetails?.auth_on_file ?? {},
        ),
      );
    }
  }, [generalOrderDetails, authOnFileDetails]);

  return potentialExhaustVisits;
};
